import { Dropdown, Menu, MenuButton, MenuItem, ListDivider, ListItem, ListSubheader, List } from '@mui/joy';
import { Avatar, Box, Typography } from '@mui/joy';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetHouseholdsQuery } from '@/features/households/api';
import { useGetProfileQuery } from '@/features/onboarding/api';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '@/features/auth/firebase';
import { sortBy } from 'lodash';
import { useLogout } from '@/hooks/useLogout';
import { useSwitchHousehold } from '@/hooks/useSwitchHousehold';

const size = 24;

export function ActiveUserMenu() {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);
  const { data: profile } = useGetProfileQuery();

  const { householdId } = useParams();
  const { data: households } = useGetHouseholdsQuery();

  const houseHoldCount = households?.data?.length;
  const logout = useLogout();
  const switchHousehold = useSwitchHousehold();
  
  const userProfile = profile?.data?.profile;
  const sortedHouseholds = sortBy(households?.data ?? [], 'name');  

  if (user == null || userProfile == null) {
    return null;
  }

  return (
    <Dropdown>
      <MenuButton
        variant="plain"
        size="sm"
        sx={{ maxWidth: `${size}px`, maxHeight: `${size}px`, borderRadius: '9999999px' }}
      >
        <Avatar src={user.photoURL} sx={{ '--Avatar-size': `${size}px` }} />
      </MenuButton>
      <Menu
        placement="bottom-end"
        size="sm"
        sx={{
          zIndex: '99999',
          p: 1,
          gap: 1,
          '--ListItem-radius': 'var(--joy-radius-sm)',
        }}
      >
        <ListItem>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Avatar src={user.photoURL} size="sm" />
            <Box sx={{ ml: 1.5 }}>
              <Typography level="title-sm" textColor="text.primary">
                {userProfile.display_name}
              </Typography>
              <Typography level="body-xs" textColor="text.tertiary">
                {user.email}
              </Typography>
            </Box>
          </Box>
        </ListItem>
        <ListDivider sx={{ mb: 0 }} />        
        <ListSubheader sx={{ mb: -1 }}>Household{houseHoldCount > 1 ? 's' : ''}</ListSubheader>
        <List>
          {sortedHouseholds.map((household) => (
            <MenuItem key={household.id} onClick={() => switchHousehold(household.id)} sx={household.id !== householdId ? { pl: '34px' } : {}}>
              {household.id === householdId && <CheckRoundedIcon />}
              {household.name}
            </MenuItem>
          ))}          
        </List>        
        <ListDivider />         
        <MenuItem onClick={() => navigate(`/h/${householdId}/settings`)}>        
          <SettingsRoundedIcon />
          Settings
        </MenuItem>       
        <ListDivider />              
        <MenuItem onClick={logout}>
          <LogoutRoundedIcon />
          Log out
        </MenuItem>
      </Menu>
    </Dropdown>
  );
}
